// Day 14 — priced reminder.

import type { EmailData } from "../../types";
import { longDate } from "../../format";
import { b, body, esc, p } from "../../layouts/chrome";
import { NO_PAYMENT, pricedEmailHtml } from "../../layouts/priced";
import { brand } from "../brand";

export const subject = ({ renewalDate }: EmailData) =>
  `Reminder: your ${brand.name} renewal on ${longDate(renewalDate)}`;

export const html = (data: EmailData) =>
  pricedEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    quotes: data.quotes ?? [],
    payment: data.payment ?? NO_PAYMENT,
    policyRef: data.policyRef,
    versionRef: data.versionRef,
    bodyHtml: p(
      `We hope you're doing well. This is a friendly reminder from ${brand.name} that your insurance policy for ${b(`'${esc(data.companyName)}' is due for renewal on ${longDate(data.renewalDate)}`)} — and it will ${b("not renew automatically")}. Renewing now keeps your cover continuous with no gaps.`,
    ),
  });
